// extracted by mini-css-extract-plugin
export default {"bold":"styles-module__bold--M8su1","spaceUnder":"styles-module__spaceUnder--i4lYs","customErrorWrapper":"styles-module__customErrorWrapper--MYdWL"};